<div
  class="notice-inline-editor-shell"
  [attr.data-editor-ready]="ready()"
  (focusin)="activated.emit()"
>
  @if (!ready() && !editorError()) {
    <div
      class="notice-inline-editor-preview"
      role="textbox"
      aria-multiline="true"
      [attr.aria-label]="ariaLabel"
      [attr.aria-readonly]="readOnly"
      [attr.tabindex]="readOnly ? -1 : 0"
      (focus)="startEditing()"
      (click)="startEditing()"
    >
      @for (run of runs; track $index) {
        @if (run.kind === "literal") {
          <span
            [style.font-weight]="run.bold ? '700' : null"
            [style.font-style]="run.italic ? 'italic' : null"
            >{{ run.value }}</span
          >
        } @else {
          <button
            type="button"
            [disabled]="readOnly"
            [attr.aria-label]="
              'Inspect ' +
              (run.kind === 'field' ? 'data' : 'terminology') +
              ' reference ' +
              run.value
            "
            [attr.aria-pressed]="
              selectedReferenceIndex === referenceOrdinal($index)
            "
            (click)="inspectPreviewReference($index, $event)"
            class="notice-reference"
            [class.notice-reference--term]="run.kind === 'term'"
            [class.notice-reference--unknown]="!knownReference(run)"
            [attr.title]="run.kind + ': ' + run.value"
            [style.font-weight]="run.bold ? '700' : null"
            [style.font-style]="run.italic ? 'italic' : null"
          >
            {{ run.kind === "field" ? "Data" : "Term" }} ·
            {{ referenceLabel(run) }}
          </button>
        }
      }
      @if (!runs.length) {
        <span class="notice-inline-editor-placeholder">Type notice text…</span>
      }
    </div>
  }
  <div [hidden]="!ready()">
    <div #surface class="notice-inline-editor-surface"></div>
  </div>
  @if (editorError()) {
    <p class="notice-inline-editor-error" role="alert">{{ editorError() }}</p>
  }
</div>
